import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList,
} from 'recharts';
import Box from '@cloudscape-design/components/box';
import { ModelMetricsAggregated, labelModel } from '../../types';

const BAR_COLORS = [
  '#0073bb', '#d13212', '#1d8102', '#8b5cf6',
  '#e07941', '#2ea597', '#c2185b', '#7b1fa2',
];

interface SuccessRateChartProps {
  models: Record<string, ModelMetricsAggregated>;
}

export const SuccessRateChart: React.FC<SuccessRateChartProps> = ({ models }) => {
  const data = Object.values(models).map((m) => ({
    name: labelModel(m),
    successRate: Math.round(m.successRate * 10) / 10,
  }));

  if (data.length === 0) {
    return (
      <Box textAlign="center" color="text-status-inactive" padding="l">
        No success rate data available
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis domain={[0, 100]} />
        <Tooltip />
        <Bar dataKey="successRate" name="Success Rate (%)">
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={BAR_COLORS[index % BAR_COLORS.length]} />
          ))}
          <LabelList dataKey="successRate" position="top" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
